export function getLinkTargetPath(node: Element | null) {
    if (!node) return null;

    const href = node.getAttribute('href');

    if (href && href.match(/^http/)) {
        return href.replace(/^http[s]{0,1}:\/\/.[^/]+[/]*/, '/');
    }

    return href;
}
export default getLinkTargetPath;
